const CACHE_DURATION_MS = 10 * 60 * 1000;
let cachedRates = null;
let cachedAt = 0;

export async function getExchangeRates() {
  if (cachedRates && Date.now() - cachedAt < CACHE_DURATION_MS) {
    return cachedRates;
  }

  const response = await fetch('https://open.er-api.com/v6/latest/USD');
  if (!response.ok) throw new Error('Exchange rates are unavailable right now.');

  const result = await response.json();
  if (result.result !== 'success' || !result.rates?.USD || !result.rates?.SGD || !result.rates?.LKR) {
    throw new Error('Exchange rates are unavailable right now.');
  }

  cachedRates = result.rates;
  cachedAt = Date.now();
  return cachedRates;
}

export function convertAmount(amount, from, to, rates) {
  if (from === to) return Number(amount);
  const sourceRate = rates?.[from];
  const destinationRate = rates?.[to];
  if (!sourceRate || !destinationRate) return null;
  return Number(amount) / sourceRate * destinationRate;
}

export function formatAmount(amount, currency) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}